<template>
  <div v-loading="loading">
    <el-alert
        title="选中题块查看小题并分配阅卷老师"
        type="info"
    >
    </el-alert>
    <el-alert
        title="点击【分配】导入阅卷老师清单，点击【导出】获取阅卷老师清单和导入模板，分配时需要指定题块和小题，只需要填充姓名和手机号两列"
        type="info"
    >
    </el-alert>
    <el-alert
        title="【合并】类型的题块不能按小题分配，【独立】类型的题块需要选中小题分配"
        type="info"
    >
    </el-alert>
    <el-button-group>
      <el-button type="primary" size="mini" @click="set_choices">导入
      </el-button>
      <el-button size="mini" @click="download_choice">导出</el-button>
    </el-button-group>
    <el-table :data="choice_table" size="mini"
              border
              ref="choice_table">
      <el-table-column
          prop="question_id"
          label="题块号">
      </el-table-column>
      <el-table-column
          prop="group_label"
          label="题块名称">
      </el-table-column>
      <el-table-column
          prop="question_label"
          label="小题名称">
      </el-table-column>
      <el-table-column
          label="可选项">
        <template slot-scope="scope">
          {{scope.row.choices.join()}}
        </template>
      </el-table-column>
      <el-table-column
          label="标答">
        <template slot-scope="scope">
          {{show_answers(scope.row)}}
        </template>
      </el-table-column>
      <input type="file" ref="choice_file" style="display:none" @change="on_choice_change"/>
    </el-table>
  </div>
</template>

<script>
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  import global_ from "../global";

  const admin_api = global_.admin_api;
  export default {
    name: "ChoiceForm",
    data() {
      return {
        loading: false,
        current_question_group: [],
        mode_s: {
          's': '独立',
          'm': '合并'
        }
      }
    },
    props: ["choice_table", "code"],
    methods: {
      show_answers(row) {
        let out = []
        if (row.answers.length === row.choices.length) {
          for (let i in row.choices) {
            if (row.answers[i] === true) {
              out.push(row.choices[i])
            }
          }
          if (out.length === 0) {
            return "未设置"
          }
          return out.join()
        } else {
          return "未设置"
        }
      },
      index_method(v) {
        return v
      },
      save_row(index, row) {
        row.need_save = false
        let request_data = {
          service_name: 'save_police',
          id: this.code,
          group_index: this.current_question_group.group_index,
          question_index: index,
          question: row
        }
        this.axios.post(admin_api, request_data).then(response => {
          let response_data = response.data
          this.$set(this.current_question_group.questions, index, row)
          this.$message({message: response_data['result_info'], duration: 1000, type: 'success'})
        })
      },
      set_choices() {
        this.$refs.choice_file.value=""
        this.$refs.choice_file.click()
      },
      on_choice_change(e) {
        let file = e.target.files[0];
        let fileReader = new FileReader();
        fileReader.readAsBinaryString(file);
        fileReader.onload = e => {
          this.loading = true
          let data = e.target.result;
          let wb = XLSX.read(data, {
            type: "binary"
          });
          for (let index in wb.Sheets) {
            let sheet = wb.Sheets[index];
            let _questions = XLSX.utils.sheet_to_json(sheet, {
              range: 1,
              header: ['question_id', 'group_label', 'question_label', 'choices', 'answers'],
              raw: false
            });
            let request_data = {
              service_name: 'set_choices',
              questions: _questions,
              id: this.code,
            }
            this.axios.post(admin_api, request_data).then(response => {
              let response_data = response.data
              this.choice_table = response_data['result_info']
              this.loading = false
            })
            break
          }
        }
      },
      need_save(row) {
        row.need_save = true
      },
      download_choice() {
        let d = [['题块号', '题块名名称', '小题名称', '可选项', '标答']]
        for (let _ of this.choice_table) {
          d.push([_.question_id, _.group_label, _.question_label, _.choices.join(), this.show_answers(_)])
        }
        let ws = XLSX.utils.aoa_to_sheet(d);
        let wb = XLSX.utils.book_new();
        let fn = "标答.xlsx";
        XLSX.utils.book_append_sheet(wb, ws);
        let wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        FileSaver.saveAs(
          new Blob([wbout], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
          }),
          fn
        );
      },
      get_scores(row) {
        let s = row.min_score
        let e = row.max_score
        let step = row.score_step
        let step_v = (e - s) / (step - 1)
        let out = []
        if (step < 3) {
          out = [s, e]
        } else {
          for (let i = 0; i < step - 1; i++) {
            out.push(s + step_v * i)
          }
          out.push(e)
        }
        return out
      },
    }
  }
</script>

<style>
  .el-table__row.current-row {
    font-weight: bold;
    font-size: larger;
  }

</style>